// extracted by mini-css-extract-plugin
module.exports = {"label":"venue-label-module--label--1OlBD"};